import { createPortal } from 'react-dom';
import { AuthLinks } from '@/components/AuthLinks';
import { usePageData } from '@/contexts/pageContext';
import { useQueryCustomerStatus } from '@/hooks/useQueryCustomerStatus';

const authLinksPortal = document.querySelector(
  '.header__utility__authentication',
);

export const useAuthLinks = () => {
  const { isAuthenticated, isPending } = useQueryCustomerStatus();
  const { urls } = usePageData();

  return authLinksPortal
    ? createPortal(
        <AuthLinks
          isAuthenticated={isAuthenticated}
          isPending={isPending}
          urls={urls}
        />,
        authLinksPortal,
      )
    : null;
};
